import React from 'react'
import Link from 'next/link'
import { Row, Col } from 'antd'
import CatalogNavBar from '../../catalog/catalog-nav-bar'
import UserBar from '../user-bar'

const MobileHeader = () => (
    <Row>
      <Col className='nav-bar-row' span={4}>
        <CatalogNavBar />
      </Col>

      <Col span={16} className='mobile-header-logo'>
        <Link href='/'>
          <a className='logo'></a>
        </Link>
      </Col>

      <Col className='nav-bar-buttons' span={4}>
        <UserBar />
      </Col>
    </Row>
)

export default MobileHeader
